var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackButton = function SvgBackButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.424,
    height: 18.56,
    viewBox: "0 0 11.424 18.56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1082.921,386.187q3.744,7.68,3.744,8.448t-1.728.767a17.354,17.354,0,0,1-2.768-.175,4.035,4.035,0,0,1-1.376-.4,4.452,4.452,0,0,1-.864-.864q-.528-.639-2.609-3.856t-2.079-3.919q0-.7,2.208-3.873.8-1.152,1.68-2.4t1.088-1.569a3.3,3.3,0,0,1,.512-.608,3.757,3.757,0,0,1,1.408-.592,10.882,10.882,0,0,1,2.816-.3q1.711,0,1.712,1.12Q1086.665,378.634,1082.921,386.187Z",
    transform: "translate(-1075.241 -376.842)",
    fill: "#ffc800"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-button.e4e3b5fb.svg";
export { ForwardRef as ReactComponent };